import { render, staticRenderFns } from "./AnonBenchmarksIcon.vue?vue&type=template&id=f04c67be&scoped=true"
import script from "./AnonBenchmarksIcon.vue?vue&type=script&lang=js"
export * from "./AnonBenchmarksIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c67be",
  null
  
)

export default component.exports